export enum VARIANTS {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}
